let index = 0;

export default {
  generate() {
    return 'mui-id-' + (index++);
  },
};



/** WEBPACK FOOTER **
 ** ../src/utils/unique-id.js
 **/